export const getDomainVariant = () => {
  const host = window.location.hostname.toLowerCase();

  // Handles both www.thenutrafox.in and thenutrafox.in
  if (host === "thenutrafox.in" || host.endsWith(".thenutrafox.in")) return "IN";

  // Handles both www.thenutrafox.com and thenutrafox.com
  if (host === "thenutrafox.com" || host.endsWith(".thenutrafox.com")) return "GLOBAL";

  // Fallback (useful for vercel preview domains)
  return "GLOBAL";
};